import { Button, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material"
import { useState } from "react"

// Dialog body used with `useDialog`. The dialog system injects `ok` / `cancel` and `pass`
// (the props passed to the returned opener). Resolving via `ok(text)` returns the edited
// content to the caller; `cancel()` resolves with the dialog's default (falsy) value.
export function ShareLinkCommentEditDialog({ ok, cancel, initialBody = "" }) {
    const [body, setBody] = useState(initialBody)
    const trimmed = body.trim()
    const disabled = !trimmed || trimmed === initialBody.trim()

    return (
        <>
            <DialogTitle>Edit comment</DialogTitle>
            <DialogContent sx={{ mt: 1 }}>
                <TextField
                    autoFocus
                    fullWidth
                    multiline
                    minRows={3}
                    size="small"
                    label="Comment"
                    value={body}
                    onChange={handleChange}
                    data-cy="share-link-comment-edit-input"
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={cancel} color="secondary" data-cy="share-link-comment-edit-cancel">
                    Cancel
                </Button>
                <Button
                    onClick={save}
                    color="primary"
                    variant="contained"
                    disabled={disabled}
                    data-cy="share-link-comment-edit-save"
                >
                    Save
                </Button>
            </DialogActions>
        </>
    )

    function handleChange(event) {
        setBody(event.target.value)
    }

    function save() {
        ok(trimmed)
    }
}
